import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern Living kit — a rectangular dining table, 1.6 x 0.9 m, top at 0.75 m,
// authored at true metric size, centred on the origin, base on y = 0.
const OAK = "#c8975a";
const MATTE_BLACK = "#2e2e30";

export const diningTable = defineModel({
  id: "dining-table",
  batchId: "modern",
  name: "Dining table",
  tags: ["modern", "interior", "furniture", "dining", "table"],
  summary: "A rectangular oak dining table on four matte-black legs.",
  tiles: { w: 2, h: 1 },
  footprint: 1.2,
  parts(): Part[] {
    const legs: Part[] = [];
    for (const x of [-0.72, 0.72]) {
      for (const z of [-0.38, 0.38]) {
        legs.push({
          geometry: new THREE.BoxGeometry(0.06, 0.7, 0.06),
          color: MATTE_BLACK,
          position: [x, 0.35, z],
        });
      }
    }
    return [
      // oak top (top surface at 0.75)
      { geometry: new THREE.BoxGeometry(1.6, 0.05, 0.9), color: OAK, position: [0, 0.725, 0] },
      // slim apron under the top
      { geometry: new THREE.BoxGeometry(1.44, 0.08, 0.74), color: MATTE_BLACK, position: [0, 0.66, 0] },
      ...legs,
    ];
  },
  animations: [],
});
